import React, { useState } from 'react';
import { FiFileText, FiHelpCircle, FiCheck, FiPlus } from 'react-icons/fi';
import SettingsModal from '../SettingsModal';
import { STANDARD_FILTERS } from './announcementData';

interface Props {
    existing: string[];
    onClose: () => void;
    onAdd: (words: string[]) => void;
}

// the first four housekeeping lodgements start ticked (spec); ones already on the page show ticked and can't be changed
const StandardFilterModal: React.FC<Props> = ({ existing, onClose, onAdd }) => {
    const added = (w: string) => existing.some(x => x.toLowerCase() === w.toLowerCase());
    const [picked, setPicked] = useState<string[]>(() => STANDARD_FILTERS.slice(0, 4).map(x => x.word).filter(w => !added(w)));

    const flip = (w: string) => setPicked(p => p.includes(w) ? p.filter(x => x !== w) : [...p, w]);
    const half = Math.ceil(STANDARD_FILTERS.length / 2);
    const columns = [STANDARD_FILTERS.slice(0, half), STANDARD_FILTERS.slice(half)];

    return <SettingsModal wide icon={<FiFileText />} title="Add Standard Filter Words" sub="Announcements with these words in the headline are never emailed automatically" onClose={onClose}
        footerNote="You can remove any of them afterwards."
        footer={<button type="button" className="btn-primary" onClick={() => onAdd(picked)} disabled={picked.length === 0}>
            <FiPlus /> Add {picked.length} {picked.length === 1 ? 'Filter' : 'Filters'}
        </button>}>
        <div className="info-note"><span className="icon-tile"><FiHelpCircle /></span>These are the housekeeping lodgements most companies leave out. You can still email one by hand from Announcements.</div>
        <div className="columns check-columns">
            {columns.map((col, i) => <div key={i} className="col">
                {col.map(f => {
                    const already = added(f.word);
                    const on = already || picked.includes(f.word);
                    return <button key={f.word} type="button" role="checkbox" aria-checked={on} disabled={already}
                        className={`check-row${on ? ' on' : ''}`} onClick={() => flip(f.word)}>
                        <span className="box">{on && <FiCheck />}</span>
                        <span className="text"><strong>{f.word}</strong><span>{already ? 'Already added' : f.hint}</span></span>
                    </button>;
                })}
            </div>)}
        </div>
    </SettingsModal>;
};

export default StandardFilterModal;
